import { useAuth0 } from '@auth0/auth0-react'
import { Dialog, DialogContent, DialogDescription, DialogHeader } from '@dfh-corp-sites/ui'
import React from 'react'

import useSiteMetadata from '../../hooks/useSiteMetadata'
import {
  closeDisabledRegistrationModal,
  openDisabledRegistrationModal,
  useDisabledRegistrationModalState,
} from '../../lib/auth/disable-registration'
import RegistrationLink from '../global/RegistrationLink'

const DisabledSignupModal = () => {
  const { isAuthenticated } = useAuth0()
  const { featureFlags } = useSiteMetadata() ?? {}
  const { isOpen, accountType, page } = useDisabledRegistrationModalState()

  if (!featureFlags?.disabledRegistration || isAuthenticated) {
    return null
  }

  const handleOpenChange = (open: boolean) => {
    open
      ? openDisabledRegistrationModal({
          page,
          accountType,
        })
      : closeDisabledRegistrationModal()
  }

  return (
    <Dialog onOpenChange={handleOpenChange} open={isOpen}>
      <DialogContent className="max-w-2xl py-1">
        <DialogHeader className="text-2xl text-brand-navy font-medium mb-8 mt-10 px-2.5 md:px-5 xl:px-[30px]">
          Account registration disabled
        </DialogHeader>
        <div className="px-2.5 md:px-5 xl:px-[30px] mb-8">
          <DialogDescription>
            Account registration is currently unavailable. If you’d like to create an account, visit
            our classic site and return to this site after signing up.{' '}
            <RegistrationLink classic page={page} accountType={accountType}>
              www.designsforhealth.com
            </RegistrationLink>
            .
          </DialogDescription>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DisabledSignupModal
